import { emailRegex as defaultEmailRegex } from "./regex-constants";
import { throttle } from "lodash-es";

export const isEmailValid = (
  email: string,
  emailRegex: RegExp = defaultEmailRegex
) => emailRegex.test(email);

const VALIDATE_THROTTLE_DURATION = 1000;

export const validateEmail = throttle(
  ({
    validate,
    emailRegex = defaultEmailRegex,
    email,
    validateEmpty = false,
    onInvalid,
    onValid,
  }) => {
    if (!validate) return;

    if (
      email &&
      (emailRegex.test(email) || (email === "" && validateEmpty === false))
    ) {
      onValid();
    } else {
      onInvalid("contactInfoEmailError");
    }
  },
  VALIDATE_THROTTLE_DURATION
);
